export default "__VITE_ASSET__5wp$RNhxvUvkhGFewhr33Q__"